import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bar } from "react-chartjs-2";
import axios from "axios"; 
import "../../Styles/reports.css";
import report from '../../assets/report.png';
import report1 from '../../assets/report1.png';
import seoreport from '../../assets/seo-report.png';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../Components/Loader";

function Reports() {
    const [ticketCounts, setTicketCounts] = useState({ adminCount: 0, facultyCount: 0, studentCount: 0 });
    const [pageLoading, setPageLoading] = useState(true); 

    useEffect(() => {
        const fetchTicketCounts = async () => {
            const token = localStorage.getItem("authToken");
            try {
                const response = await axios.get("https://api.uniums.com/api/tickets/ticket-counts", {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setTicketCounts(response.data);
            } catch (error) {
                console.error("Error fetching ticket counts:", error);
                toast.error("Failed to fetch ticket counts");
            } finally {
                setPageLoading(false);
            }
        };

        fetchTicketCounts();
    }, []);

    const data = {
        labels: ["Admins", "Faculty", "Students"],
        datasets: [
            {
                label: "Report Ratio",
                data: [ticketCounts.adminCount, ticketCounts.facultyCount, ticketCounts.studentCount],
                backgroundColor: [
                    "rgba(255, 99, 132, 0.2)",
                    "rgba(54, 162, 235, 0.2)",
                    "rgba(75, 192, 192, 0.2)"
                ],
                borderColor: [
                    "rgba(255, 99, 132, 1)",
                    "rgba(54, 162, 235, 1)",
                    "rgba(75, 192, 192, 1)"
                ],
                borderWidth: 1
            }
        ]
    };

    const options = {
        scales: {
            y: {
                beginAtZero: true
            }
        }
    };

    if (pageLoading) {
        return <Loader />; 
    }

    return (
        <div className="reports-page">
            <h1 className="reports-title">Super Admin Report</h1>

            <div className="report-cards">
                <Link to="/view-report" className="report-card admin-report">
                    <div className="icon">
                        <img src={report} alt="admin report" />
                    </div>
                    <h2>Admin Report</h2>
                    <p className="number">{ticketCounts.adminCount}</p>
                </Link>

                <Link to="/view-report" className="report-card faculty-report">
                    <div className="icon"><img src={report1} alt="faculty report" /></div>
                    <h2>Faculty Report</h2>
                    <p className="number">{ticketCounts.facultyCount}</p>
                </Link>

                <Link to="/view-report" className="report-card student-report">
                    <div className="icon">           
                     <img src={seoreport} alt="student report" />
                    </div>
                    <h2>Student Report</h2>
                    <p className="number">{ticketCounts.studentCount}</p>
                </Link>
            </div>

            <div className="report-graph">
                <h2>Report Ratio Overview</h2>
                <Bar data={data} options={options} />
            </div>
        </div>
    );
}

export default Reports;
